// Màn đăng nhập: username/mật khẩu; lỗi hiện đỏ; nút khoá khi đang gửi; ô TOTP hiện khi server trả details.needTotp.
import { api, ApiError, errMsg } from "../api";
import { h } from "../dom";
import type { User } from "../types";

export function renderLogin(root: HTMLElement, onDone: (u: User) => void): void {
  const user = h("input", { name: "username", autocomplete: "username", required: true, autofocus: true, title: "Tên đăng nhập do Super Boss cấp", "data-testid": "login-user" });
  const pass = h("input", { name: "password", type: "password", autocomplete: "current-password", required: true, title: "Mật khẩu tài khoản Boss", "data-testid": "login-pass" });
  const totp = h("input", { name: "totp", inputmode: "numeric", autocomplete: "one-time-code", placeholder: "6 số", title: "Mã 6 số đang hiện trên ứng dụng xác thực (đổi mỗi 30 giây)", "data-testid": "login-totp" });
  const totpWrap = h("label", { class: "f", hidden: true, "data-testid": "login-totp-wrap" }, h("span", {}, "Mã 2 lớp (6 số trên ứng dụng xác thực)"), totp);
  const err = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "login-error" });
  const btn = h("button", { type: "submit", class: "pri", title: "Đăng nhập vào Boss bằng tài khoản trên (Enter cũng được)", "data-testid": "login-submit" }, "Đăng nhập");
  const form = h("form", { class: "card login-form", novalidate: true },
    h("label", { class: "f" }, h("span", {}, "Tên đăng nhập"), user),
    h("label", { class: "f" }, h("span", {}, "Mật khẩu"), pass),
    totpWrap,
    err,
    h("div", { class: "row end" }, btn));
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (btn.disabled) return;
    err.hidden = true;
    const username = user.value.trim();
    if (!username || !pass.value) {
      err.textContent = "Nhập tên đăng nhập và mật khẩu";
      err.hidden = false;
      return;
    }
    btn.disabled = true;
    btn.textContent = "Đang đăng nhập…";
    try {
      const body: Record<string, string> = { username, password: pass.value };
      if (!totpWrap.hidden && totp.value.trim()) body.totp = totp.value.trim();
      const u = await api<User>("POST", "/api/login", body);
      onDone(u);
    } catch (ex) {
      const d = ex instanceof ApiError ? (ex.details as { needTotp?: boolean } | undefined) : undefined;
      if (d?.needTotp) {
        totpWrap.hidden = false;
        totp.focus();
      }
      err.textContent = errMsg(ex);
      err.hidden = false;
    } finally {
      btn.disabled = false;
      btn.textContent = "Đăng nhập";
    }
  });
  root.append(h("div", { class: "login" }, h("h1", {}, "Boss — đăng nhập"), form,
    h("p", { class: "muted small", style: "text-align:center" }, "Trang điều khiển nhiều autoBot. Phiên lưu bằng cookie do máy chủ đặt."),
    h("p", { class: "muted small", style: "text-align:center", "data-testid": "login-help" }, "Quên mật khẩu? Không tự đặt lại được — nhờ Super Boss đổi ở trang Tài khoản.")));
  user.focus();
}
